import { takeEvery, put, all, call } from 'redux-saga/effects';
import * as types from './transactionActionTypes';
import * as actions from './transactionActions';
import * as endpoints from '../../services/endpoints';
import * as projectActions from '../project/projectActions'

const resolveAssetType = (creds = {}) => {
  if (typeof creds?.asset_type === 'string' && creds.asset_type.trim()) {
    return creds.asset_type.trim().toLowerCase();
  }

  if (creds?.action === 'mint') {
    return 'nft';
  }

  return 'token';
};

const resolveTransactionHash = (creds = {}) => {
  if (typeof creds?.transaction_hash === 'string') {
    return creds.transaction_hash;
  }

  if (creds?.transaction_hash == null) {
    return '';
  }

  return String(creds.transaction_hash);
};

function* transactionSaga({ creds }) {
  try {
    const payload = {
      ...creds,
      asset_type: resolveAssetType(creds),
      transaction_hash: resolveTransactionHash(creds),
    };

    const { data } = yield call(endpoints.transaction, payload);
    yield put(actions.transactionData(data));
    yield put (projectActions.getProjectByIDData(data))
  } catch (e) {
    yield put(actions.transactionError(e));
  }
}
function* watchTransaction() {
  yield takeEvery(types.TRANSACTION_REQUEST, transactionSaga);
}


export function* transactionsSaga() {
  yield all([
    watchTransaction(),
   
  ]);
}
